// src/Components/DrawBar/DrawBar.tsx
import { NavLink, useNavigate } from 'react-router';
import './DrawBar.css';
import Profil_pic from './Profil_Pic.png';
import { useProductContext } from '../../Context/ProductContext';
import { useAuth } from '../../Context/AuthContext';
import { useCartCount } from '../../stores/cartStore';
import { Home, User, ShoppingBag, Package, Info, Globe, LifeBuoy } from 'lucide-react';
import { useState, useEffect } from 'react';

const DrawBar = () => {
  const { DrawbarActive, setDrawbarActive } = useProductContext();
  const { user, customer, logout } = useAuth();
  const cartCount = useCartCount();
  const NavigateTo = useNavigate();
  const [imgError, setImgError] = useState(false);

  const isAuth = !!user;

  const handleProfileClick = () => {
    NavigateTo('/Profile/Account');
    setDrawbarActive(false);
  };

  const HandleConnexion = () => {
    setDrawbarActive(false);
    NavigateTo('/Connexion');
  };

  const HandleLogout = async () => {
    await logout();
    setDrawbarActive(false);
    NavigateTo('/');
  };

  useEffect(() => {
    const overlay = document.getElementById('DrawBar-overlay');
    if (!overlay) return;
    const handler = () => setDrawbarActive(false);
    overlay.addEventListener('click', handler);
    return () => overlay.removeEventListener('click', handler);
  }, [setDrawbarActive]);

  return (
    <>
      <div id="DrawBar-overlay" className={DrawbarActive ? 'open' : ''} />
      <div id="DrawBar" className={DrawbarActive ? 'active' : ''}>
        <button className="Profil" onClick={handleProfileClick} aria-label={isAuth ? 'Voir mon profil' : 'Se connecter'}>
          <div className="divImg">
            {isAuth && customer?.photoURL && !imgError ? (
              <img src={customer.photoURL} alt="Profil" onError={() => setImgError(true)} />
            ) : (
              <img src={Profil_pic} alt="Profil" />
            )}
          </div>
          <div className="Profil_info">
            <span className="profile-name">
              {isAuth && customer?.displayName
                ? customer.displayName
                : isAuth && customer?.email
                ? customer.email.split('@')[0]
                : 'Nom et Prénoms'}
            </span>
            <span className="profile-phone">
              {isAuth && customer?.phone ? customer.phone : 'Numéro de téléphone'}
            </span>
          </div>
        </button>
        <nav className="menu-items" onClick={() => setDrawbarActive(false)}>
          <NavLink to="/Home" className={({ isActive }) => (isActive ? 'active' : '')}>
            <Home size={20} strokeWidth={1.5} />
            <span className="menu-item-label">Accueil</span>
          </NavLink>
          <NavLink to="/Profile/Account" className={({ isActive }) => (isActive ? 'active' : '')}>
            <User size={20} strokeWidth={1.5} />
            <span className="menu-item-label">Mon compte</span>
          </NavLink>
          <NavLink to="/Profile/Basket" className={({ isActive }) => (isActive ? 'active' : '')}>
            <ShoppingBag size={20} strokeWidth={1.5} />
            <span className="menu-item-label">Le panier</span>
            {cartCount > 0 && (
              <span className="menu-badge">{cartCount > 99 ? '99+' : cartCount}</span>
            )}
          </NavLink>
          <div className="menu-divider" />
          <NavLink to="/Profile/Orders" className={({ isActive }) => (isActive ? 'active' : '')}>
            <Package size={20} strokeWidth={1.5} />
            <span className="menu-item-label">Mes commandes</span>
          </NavLink>
          <NavLink to="/Import" className={({ isActive }) => (isActive ? 'active' : '')}>
            <Globe size={20} strokeWidth={1.5} />
            <span className="menu-item-label">Commander à l'international</span>
          </NavLink>
          <NavLink to="/Profile/Support" className={({ isActive }) => (isActive ? 'active' : '')}>
            <LifeBuoy size={20} strokeWidth={1.5} />
            <span className="menu-item-label">Aide &amp; réclamations</span>
          </NavLink>
          <NavLink to="/Profile/About" className={({ isActive }) => (isActive ? 'active' : '')}>
            <Info size={20} strokeWidth={1.5} />
            <span className="menu-item-label">À propos</span>
          </NavLink>
        </nav>
        <div className="menu-auth-section">
          <button
            className="login-draw-btn"
            onClick={isAuth ? HandleLogout : HandleConnexion}
            style={isAuth ? { backgroundColor: '#2E2E2E', color: '#7A7570' } : {}}
          >
            {isAuth ? 'Déconnexion' : 'Connexion'}
          </button>
        </div>
        <div className="menu-footer">Ornoir Market &copy; 2025</div>
      </div>
    </>
  );
};

export default DrawBar;
